import { Monitor, Moon, Sun } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { THEME_OPTIONS } from '../../utils/theme';

const ICONS = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

export function ThemeOption({ value, current, onSelect }) {
  const Icon = ICONS[value];
  const selected = current === value;
  const labels = pt.settings.appearance.options;

  return (
    <button
      type="button"
      onClick={() => onSelect(value)}
      className={`flex w-full items-start gap-3 rounded-xl border p-4 text-left transition-colors ${
        selected
          ? 'border-sage-500 bg-sage-50 dark:border-sage-600 dark:bg-sage-900/30'
          : 'border-border bg-card hover:bg-muted'
      }`}
      aria-pressed={selected}
    >
      <span
        className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-lg ${
          selected
            ? 'bg-sage-500 text-white'
            : 'bg-muted text-muted-foreground'
        }`}
      >
        <Icon className="h-5 w-5" aria-hidden />
      </span>
      <span>
        <span className="block font-medium text-foreground">{labels[value].title}</span>
        <span className="mt-0.5 block text-sm text-muted-foreground">
          {labels[value].description}
        </span>
      </span>
    </button>
  );
}

/** Lista de opções de tema (claro / escuro / sistema). */
export function ThemePicker({ current, onSelect }) {
  return (
    <div className="space-y-3">
      {THEME_OPTIONS.map((option) => (
        <ThemeOption
          key={option}
          value={option}
          current={current}
          onSelect={onSelect}
        />
      ))}
    </div>
  );
}
